import { useMemo } from "react";
import {
  convertMetersToMiles,
  convertSecondsIntoHoursMinutesSeconds,
} from "../../../helpers/utilities";
import { dedicatedOrderStatuses } from "../DedicatedDispatchConstants";
import { Polyline } from "./Polyline";

export const MapRoute = ({
  route,
  legStatuses,
  simple, //if simple, use path with array of coordinates instead of encodedPath string //https://developers.google.com/maps/documentation/javascript/shapes
  closeInfoWindowNotif,
}) => {
  // console.log("route", route);
  // const polyLines = route.legs[0].steps
  // const polyLine = route?.legs?.[0]?.polyline?.encodedPolyline;
  // const polyLines = [route.polyline.encodedPolyline]; The whole route as one polyline, put in array as a quick test since down below I map through polyLines.

  let simpleRouteBuilder = [];
  const routeLegs = route?.legs;

  const originCoordinates = {
    lat: routeLegs?.[0]?.startLocation?.latLng.latitude,
    lng: routeLegs?.[0]?.startLocation?.latLng.longitude,
  };
  simpleRouteBuilder.push(originCoordinates);
  for (let i = 0; i < routeLegs?.length; i++) {
    const destinationCoordinates = {
      lat: routeLegs?.[i]?.endLocation?.latLng.latitude,
      lng: routeLegs?.[i]?.endLocation?.latLng.longitude,
    };
    simpleRouteBuilder.push(destinationCoordinates);
  }

  const simpleRoute = [];
  for (let i = 0; i < simpleRouteBuilder.length - 1; i++) {
    simpleRoute.push({
      polyLine: [simpleRouteBuilder[i], simpleRouteBuilder[i + 1]],
      distance: convertMetersToMiles(routeLegs[i]?.distanceMeters),
      duration: convertSecondsIntoHoursMinutesSeconds(
        routeLegs[i]?.duration.slice(0, -1),
        true
      ),
      status: routeLegs[i].status,
    });
  }

  const polyLines = simple
    ? simpleRoute
    : route?.legs?.map((leg) => {
        return {
          polyLine: leg.polyline.encodedPolyline,
          distance: convertMetersToMiles(leg.distanceMeters),
          duration: convertSecondsIntoHoursMinutesSeconds(
            leg.duration.slice(0, -1),
            true
          ),
          status: leg.status,
        };
      });

  // console.log("polylines", polyLines);

  //if you want to do each step as it's own polyline, ONLY DOES FIRST LEG, map through the legs instead if switching to this.
  // const polyLines = route?.legs?.[0]?.steps?.map((step) => {
  //   return step?.polyline?.encodedPolyline;
  // });
  const colors = ["blue", "red", "orange", "green", "cyan", "coral"];
  const coloredSteps = (index) => {
    return colors[index];
  };

  // Starts at bright blue and gets darker per leg
  // const bluegrade = (index) => {
  //   return `rgb(0,0,${255 - index * 50})`;
  // };
  // Random colors, but sometimes some of the lines blend in with the bg
  // const max = 255;
  // const min = 0;
  // const randomColor = () => {
  //   return `rgb(${Math.random() * (max - min) + min},${Math.random() * (max - min) + min},${Math.random() * (max - min) + min})`;
  // };

  const polyLinesMemo = useMemo(() => {
    if (!polyLines) {
      return null;
    }
    return polyLines.map((polyLine, index) => (
      <Polyline
        key={`${Math.random(0, 1)},${index}-polyline`}
        encodedPath={simple ? null : polyLine.polyLine}
        path={simple ? polyLine.polyLine : null}
        strokeWeight={6}
        closeInfoWindowNotif={closeInfoWindowNotif}
        infoWindowMessage={
          // !simple && ( if we make the simple route not based on the computeRoutes api to save on cost later, we wouldn't have the duration/distance data to show
          <>
            {/* <div className="font-600 mb-2">Route Leg Info</div> */}
            {/* <span style={{ bakcgroundColor: "black", fontWeight: "500" }}>
            Duration: {polyLine.duration?.hours}H {polyLine.duration?.minutes}M
            <br />
            Distance:{" "}
            {`${polyLine.distance?.toFixed(2)} mile${
              parseFloat(polyLine.distance.toFixed(2)) === 1 ? "" : "s"
            }`}
          </span> */}
            <span style={{ bakcgroundColor: "black", fontWeight: "500" }}>
              Time: {polyLine.duration?.hours}h {polyLine.duration?.minutes}m
              <br />
              Distance:{" "}
              {`${polyLine.distance?.toFixed(2)} mile${
                parseFloat(polyLine.distance.toFixed(2)) === 1 ? "" : "s"
              }`}
            </span>
          </>
          // )
        }
        // strokeColor={coloredSteps(index)}
        //status can be embedded into each leg object or passed separately
        strokeColor={
          polyLine.status === dedicatedOrderStatuses.completed ||
          legStatuses?.[index] === dedicatedOrderStatuses.completed
            ? "gray"
            : polyLine.status === dedicatedOrderStatuses.missed ||
              legStatuses?.[index] === dedicatedOrderStatuses.missed
            ? "red"
            : "blue"
        }
      />
    ));
  }, [route, legStatuses, simple, closeInfoWindowNotif]);

  return polyLinesMemo;
};
